<app-modal [isOpen]="isOpen" (close)="onClose()" className="max-w-lg mx-4">
  <div class="p-6">
    <h4 class="text-lg font-semibold text-gray-800 dark:text-white/90 mb-1">Crear formulario</h4>
    <p class="text-sm text-gray-500 dark:text-gray-400 mb-5">Elige cómo quieres comenzar</p>

    <!-- Mode toggle -->
    @if (!isTemplate) {
      <div class="flex gap-2 p-1 bg-gray-100 dark:bg-gray-800 rounded-xl mb-5">
        <button type="button"
          (click)="setMode('new')"
          class="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-medium rounded-lg transition-all"
          [class.bg-white]="mode === 'new'"
          [class.dark:bg-gray-700]="mode === 'new'"
          [class.text-gray-900]="mode === 'new'"
          [class.dark:text-white]="mode === 'new'"
          [class.shadow-sm]="mode === 'new'"
          [class.text-gray-500]="mode !== 'new'"
          [class.dark:text-gray-400]="mode !== 'new'"
        >
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v14M5 12h14"/>
          </svg>
          En blanco
        </button>
        <button type="button"
          (click)="setMode('from-template')"
          class="flex-1 flex items-center justify-center gap-1.5 px-3 py-2 text-xs font-medium rounded-lg transition-all"
          [class.bg-white]="mode === 'from-template'"
          [class.dark:bg-gray-700]="mode === 'from-template'"
          [class.text-gray-900]="mode === 'from-template'"
          [class.dark:text-white]="mode === 'from-template'"
          [class.shadow-sm]="mode === 'from-template'"
          [class.text-gray-500]="mode !== 'from-template'"
          [class.dark:text-gray-400]="mode !== 'from-template'"
        >
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"/>
          </svg>
          Desde plantilla
        </button>
      </div>
    }

    <!-- Nombre interno -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
        Nombre del formulario <span class="text-gray-400 font-normal">(interno)</span>
      </label>
      <input
        type="text"
        [formControl]="nameControl"
        placeholder="Ej. Formulario de contacto"
        class="w-full px-3.5 py-2.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition"
      />
      <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">Solo para identificarlo en tus listados del CRM. No se muestra al público.</p>
    </div>

    <!-- Título visible (solo en modo nuevo) -->
    @if (mode === 'new') {
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
          Título del formulario <span class="text-gray-400 font-normal">(visible)</span>
        </label>
        <input
          type="text"
          [formControl]="titleControl"
          placeholder="Ej. Contáctanos"
          class="w-full px-3.5 py-2.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition"
        />
        <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">Es lo que verá quien complete el formulario. Si lo dejas vacío se usará el nombre.</p>
      </div>
    }

    <!-- MODE: new ─────────────────────────────────────────────────────────── -->
    @if (mode === 'new') {

      <!-- Descripcion (opcional) -->
      <div class="mb-5">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
          Descripción <span class="text-gray-400 font-normal">(opcional)</span>
        </label>
        <textarea
          [formControl]="descriptionControl"
          rows="2"
          placeholder="Referencia interna para tu equipo — no se muestra en el formulario"
          class="w-full px-3.5 py-2.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition resize-none"
        ></textarea>
      </div>

      <!-- Tipo de formulario -->
      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Tipo de formulario
        </label>
        <div class="grid grid-cols-2 gap-3">
          @for (opt of typeOptions; track opt.value) {
            <button
              type="button"
              (click)="selectedType = opt.value"
              class="flex items-start gap-3 p-3.5 rounded-xl border-2 transition-all text-left"
              [class.border-brand-500]="selectedType === opt.value"
              [class.bg-brand-50]="selectedType === opt.value"
              [class.dark:bg-brand-500/10]="selectedType === opt.value"
              [class.border-gray-200]="selectedType !== opt.value"
              [class.dark:border-gray-700]="selectedType !== opt.value"
              [class.hover:border-gray-300]="selectedType !== opt.value"
              [class.dark:hover:border-gray-600]="selectedType !== opt.value"
            >
              <span
                class="mt-0.5 flex-shrink-0"
                [class.text-brand-500]="selectedType === opt.value"
                [class.text-gray-400]="selectedType !== opt.value"
                [innerHTML]="opt.icon"
              ></span>
              <span class="flex flex-col">
                <span class="text-sm font-medium text-gray-800 dark:text-white/90">{{ opt.label }}</span>
                <span class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ opt.description }}</span>
              </span>
            </button>
          }
        </div>
      </div>
    }

    <!-- MODE: from-template ─────────────────────────────────────────────── -->
    @if (mode === 'from-template') {

      <!-- Descripción (opcional) -->
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
          Descripción <span class="text-gray-400 font-normal">(opcional)</span>
        </label>
        <textarea
          [formControl]="descriptionControl"
          rows="2"
          placeholder="Breve descripción del propósito del formulario"
          class="w-full px-3.5 py-2.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition resize-none"
        ></textarea>
      </div>

      <div class="mb-5">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Selecciona una plantilla
        </label>

        @if (templatesLoading) {
          <div class="grid grid-cols-2 gap-2">
            @for (i of [1,2,3,4]; track i) {
              <div class="h-16 rounded-xl bg-gray-100 dark:bg-gray-800 animate-pulse"></div>
            }
          </div>
        } @else if (templates.length === 0) {
          <div class="flex flex-col items-center justify-center gap-2 py-8 text-center border-2 border-dashed border-gray-200 dark:border-gray-700 rounded-xl">
            <svg class="w-8 h-8 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"/>
            </svg>
            <p class="text-xs text-gray-500 dark:text-gray-400">No hay plantillas disponibles todavía.</p>
          </div>
        } @else {
          <div class="grid grid-cols-2 gap-2 max-h-52 overflow-y-auto pr-1">
            @for (tpl of templates; track tpl.id) {
              <button
                type="button"
                (click)="selectTemplate(tpl)"
                class="flex items-center gap-2.5 p-3 rounded-xl border-2 text-left transition-all"
                [class.border-brand-500]="selectedTemplate?.id === tpl.id"
                [class.bg-brand-50]="selectedTemplate?.id === tpl.id"
                [class.dark:bg-brand-500/10]="selectedTemplate?.id === tpl.id"
                [class.border-gray-200]="selectedTemplate?.id !== tpl.id"
                [class.dark:border-gray-700]="selectedTemplate?.id !== tpl.id"
                [class.hover:border-gray-300]="selectedTemplate?.id !== tpl.id"
                [class.dark:hover:border-gray-600]="selectedTemplate?.id !== tpl.id"
              >
                <div class="flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center"
                  [class.bg-brand-100]="selectedTemplate?.id === tpl.id"
                  [class.dark:bg-brand-500/20]="selectedTemplate?.id === tpl.id"
                  [class.bg-gray-100]="selectedTemplate?.id !== tpl.id"
                  [class.dark:bg-gray-700]="selectedTemplate?.id !== tpl.id"
                >
                  <svg class="w-4 h-4"
                    [class.text-brand-500]="selectedTemplate?.id === tpl.id"
                    [class.text-gray-400]="selectedTemplate?.id !== tpl.id"
                    fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"/>
                  </svg>
                </div>
                <div class="min-w-0 flex-1">
                  <p class="text-xs font-medium text-gray-800 dark:text-white/90 truncate">{{ tpl.name }}</p>
                  <span class="inline-block mt-0.5 text-[10px] font-medium px-1.5 py-0.5 rounded" [class]="typeBadgeClass(tpl.formType)">
                    {{ typeLabel(tpl.formType) }}
                  </span>
                  @if (tpl.description) {
                    <p class="mt-1 text-[10px] text-gray-500 dark:text-gray-400 line-clamp-2 leading-tight">{{ tpl.description }}</p>
                  }
                </div>
              </button>
            }
          </div>
        }
      </div>
    }

    <!-- Acciones -->
    <div class="flex justify-end gap-3">
      <app-button variant="outline" (btnClick)="onClose()" [disabled]="loading">
        Cancelar
      </app-button>
      <app-button
        variant="primary"
        [disabled]="!canSubmit || loading"
        (btnClick)="onSubmit()"
      >
        @if (loading) {
          <span class="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full"></span>
        }
        {{ mode === 'from-template' ? 'Crear desde plantilla' : 'Crear formulario' }}
      </app-button>
    </div>
  </div>
</app-modal>
